const branchOptions = [
  "Assentoft",
  "Auning",
  "Billum",
  "Billund",
  "Bjerringbro",
  "Brædstrup",
  "Ebeltoft",
  "Erhvervscenter Nordjyl.",
  "Esbjerg",
  "Esbjerg Erhverv",
  "Esbjerg Privat",
  "Fredericia",
  "Frederiksberg",
  "Fællesservice (35)",
  "Galten",
  "Grenaa",
  "Hadsten",
  "Hammel",
  "Hammel Erhverv",
  "Hedensted",
  "Herning",
  "Hinnerup",
  "Holbæk",
  "Holbæk Erhverv",
  "Horsens",
  "Horsens erhverv",
  "Horsens Privat",
  "Hørning",
  "Kbh. Kongens Nytorv",
  "Kolding",
  "Kolding Erhverv",
  "Kolding Privat",
  "KRON - digital bank",
  "København C. erhverv",
  "København City",
  "Køge",
  "Køge Erhverv",
  "Landbrug",
  "Lyngby",
  "Mariager",
  "Medarbejderbanken",
  "Middelfart",
  "Odder",
  "Odense",
  "Odense Erhverv",
  "Odense Privat",
  "Randers City",
  "Randers Nordre",
  "Randers, Erhverv",
  "Randers, Vorup",
  "Roskilde",
  "Ry",
  "Silkeborg",
  "Skanderborg",
  "Skanderborg Erhverv",
  "Slagelse",
  "Spentrup",
  "Svendborg",
  "Tørring",
  "Vejle",
  "Viborg",
  "Vorbasse",
  "Øster Tørslev",
  "Aalborg Privat",
  "Aarhus",
  "Aarhus City lokalt erhverv",
  "Aarhus city Privat",
  "Aarhus Egå",
  "Aarhus erhverv",
  "Aarhus Nord",
  "Aarhus Nord Unge",
];

export default branchOptions;
